import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=38df1068&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=38df1068&prod&scope=true&lang=css"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=38df1068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38df1068",
  null
  
)

export default component.exports